import React from 'react';
import './landingPage.css';
import ProfileImage from './../images/BGPicture_filter.png';
import { useHistory } from 'react-router';

export default function LandingPage(){

    const history = useHistory();

    return(
        <div className="container-fluid LandingPageContainer">
            <div className="row h-100">
                <div className="col-sm-5 text-right">
                    <img className="LandingPageImage" src={ProfileImage} alt="PictureNotFound"></img>
                </div>
                <div className="col-sm-7 align-self-center text-center">
                    <h1 className="Title">MANIDEEP MADABHUSHANI</h1>
                            
                    <p className="Intro">
                        <span className="customUnderline">Software Craftsman</span> and <span className="customUnderline">Tech enthusiast</span> with energy and enthusiasm to deliver solutions for complex problems</p>
                    
                    <button className="LetsTalkBtn" onClick={() => history.push("/social")}>
                        Let's Talk
                    </button>
                </div>
            </div>
        </div>
    );
}
